import React from 'react';
import { compose } from 'redux';
import { withTranslation, WithTranslation } from 'react-i18next';
import { ModuleType } from '../../../../../types/modules';
import Zone, { ZoneGroup } from '../../../Layout/Zone';
import { ZoneType } from '../../../../../types/layout';
import withSectionFetchSpinner from '../../../../decorators/withSectionFetchSpinner';

import AdoptableSlider from './AdoptableSlider';
import CommissionSlider from './CommissionSlider';
import PremiumContentSlider from './PremiumContentSlider';
import PremiumFolderSlider from './PremiumFolderSlider';
import EmptyState from '../_partials/EmptyState';
import ShopCommissions from '../ShopCommissions';
import ShopAdoptables from '../ShopAdoptables';
import ShopPremiumFolders from '../ShopPremiumFolders';
import ShopPremiumContent from '../ShopPremiumContent';

import OwnerProfileShopAd from '@wix/da-shared-react/pkg/DealerAd/Placement/OwnerProfileShop';
import withFeatureFlags, {
  WithFeatureFlagsProps,
} from '@wix/da-react-context/pkg/flags/withFeatureFlags';

import s from './ShopAll.scss';

export interface Props {
  className?: string;
  isEmpty?: boolean;
  isOwner?: boolean;
  hasSingularContentType?: boolean;
  emptySections?: Object;
}

const defaultProps = {};

const enhance = compose(
  withSectionFetchSpinner,
  withTranslation(),
  withFeatureFlags
);
export class ShopAll extends React.Component<
  Props & WithTranslation & WithFeatureFlagsProps
> {
  static defaultProps: Props = defaultProps;

  render() {
    const { isEmpty, isOwner, emptySections, hasSingularContentType, flags } =
      this.props;
    if (isEmpty && !isOwner) {
      return <EmptyState view="large" />;
    }

    // if there is only one section and it's not empty, we want to expand it
    // to visitors to show more thumbs immediately
    const expandOnlySection =
      !isOwner && hasSingularContentType && emptySections;

    const mapModuleTypeToWidgetComponent = {
      [ModuleType.ADOPTABLES]:
        expandOnlySection && !emptySections[ModuleType.ADOPTABLES]
          ? ShopAdoptables
          : AdoptableSlider,
      [ModuleType.PREMIUM_FOLDERS]:
        expandOnlySection && !emptySections[ModuleType.PREMIUM_FOLDERS]
          ? ShopPremiumFolders
          : PremiumFolderSlider,
      [ModuleType.COMMISSIONS]:
        expandOnlySection && !emptySections[ModuleType.COMMISSIONS]
          ? ShopCommissions
          : CommissionSlider,
      [ModuleType.PREMIUM_CONTENT]:
        expandOnlySection && !emptySections[ModuleType.PREMIUM_CONTENT]
          ? ShopPremiumContent
          : PremiumContentSlider,
    };

    return (
      <div className={this.props.className}>
        {flags.includes('dealer_owner') && isOwner && (
          <div className={s['ad']}>
            <OwnerProfileShopAd />
          </div>
        )}
        <ZoneGroup>
          <Zone
            type={ZoneType.TOP_BAR}
            isRemovable={false}
            mapModuleTypeToWidgetComponent={mapModuleTypeToWidgetComponent}
            className={s['zone']}
          />
        </ZoneGroup>
      </div>
    );
  }
}

export default enhance(ShopAll) as React.ComponentType<Props>;
